import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FlorderMaterialLinesComponent } from 'app/modules/florder/florder-material-lines/florder-material-lines.component';
import { isCombinationMaterial, isPalletMaterial, Material, OrderMaterial, } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-order-material-lines',
  templateUrl: './order-material-lines.component.html',
  styleUrls: ['../../florder/florder-material-lines/florder-material-lines.component.scss'],
})
export class OrderMaterialLinesComponent extends FlorderMaterialLinesComponent<OrderMaterial> implements OnChanges {
  @Input() palletQuantity: number;
  @Input() loadedEpp: number;
  @Input() maxEpp: number;
  @Input() fullTruck: boolean;
  loadedStyle: {};
  notLoadedStyle: {};
  containsLoadedQuantities = false;

  constructor(breakpointObserver: BreakpointObserver, cd: ChangeDetectorRef) {
    super(breakpointObserver, cd);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const loaded = this.loadedEpp || 0;
    const total = this.maxEpp || 0;
    const percentage = Math.min(total > 0 ? (loaded / total) * 100 : 0, 100);
    this.loadedStyle = {
      width: percentage + '%',
    };
    this.notLoadedStyle = {
      width: 100 - percentage + '%',
    };
    if (this.materials) {
      this.containsLoadedQuantities = !!this.materials.find(m => !!m['loaded'] || !!m['unloaded']);
    }
  }
  showAsCombination(material: Material): boolean {
    return isCombinationMaterial(material) && material.palletId !== 'NO_LC';
  }

  showPallet(material: Material): boolean {
    return isPalletMaterial(material) || (isCombinationMaterial(material) && material.palletId !== 'NO_LC');
  }
}
